import { ExistingCampaignPromptPropsT } from "../../ExistingCampaignPrompt/models";

type DepsT = {
  navigate: (to: string) => void;
  removeAllPopups: () => void;
  /** Re-run the wizard's submit with campaignRetry: true, addToExist: 0 — today's "from scratch" path. */
  resubmitAsNew: () => void;
};

/**
 * spec-47 — the campaign wizard's two answers to the existing-campaign prompt. "Use existing" is a
 * NAVIGATION: the campaign page opens the delivery wizard (`?wizard=true`, Campaign.tsx). It must never
 * re-POST this campaign-creation payload with addToExist — that inserted a second Metadata(300) project
 * under the existing campaign (and the backend now answers 409 to it).
 */
export const buildExistingCampaignActions = (
  deps: DepsT
): Pick<ExistingCampaignPromptPropsT, "onUseExisting" | "onCreateNew"> => ({
  onUseExisting: (campaignId: number) => {
    deps.removeAllPopups();
    deps.navigate(`/campaigns/${campaignId}?wizard=true`);
  },
  onCreateNew: () => deps.resubmitAsNew(),
});
